// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__DmxEC","spin":"Spinner_spin__TL0qf"};